class OntarioObstetricalSignatureBlock {
    public CompletedByValue: string = "";
    public CompletedByUserContactFacetIds: string[] = [];
    public ReviewedBy: string;
    public Signature: string;
    public SignatureDate: Date | null;
    public MostResponsibleProviderSignature: string;
    public MostResponsibleProviderSignatureDate: Date | null;

    constructor(fields?: Partial<OntarioObstetricalSignatureBlock>) {
        Object.assign(this, fields);
    }
}

export { OntarioObstetricalSignatureBlock };
